// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"styles_avatarContainer__19oSj","avatarTitle":"styles_avatarTitle__2Rcaf","active":"styles_active__CBWJw"};